import { TextInput, PasswordInput } from "../components/Inputs";
import { Selectinput } from "../components/Inputs";
import { mccCodes } from "../constants/MccCode";
import StatesSelect from "../components/StatesSelect";
import useBusinessDetails from "../hooks/useBusinessDetails";
import { Button } from "../components/Button";

export default function BusinessDetails({ profile, setStep, setProfile }: any) {
    const {handleInputChange, handleNext, generateMccOptions, generateCompanyTypeOptions, formData, errmsg, saving} = useBusinessDetails(profile, setStep, setProfile)
    
    return (
        <div>
            <div className="mb-4">
                <TextInput label="Business Name" name="businessName" value={formData.businessName} onChange={handleInputChange} />
            </div>
            <div className="mb-4">
                <label className="block text-sm font-medium mb-1">Doing business as</label>
                <TextInput name="doingBusinessAs" value={formData.doingBusinessAs} onChange={handleInputChange} />
            </div>
            <div className="mb-4">
                <label className="block text-sm font-medium mb-1">Business Description</label>
                <textarea className="px-2 py-1 focus:outline-none border w-full min-h-20 rounded appearance-none" name="businessDescription" value={formData.businessDescription} onChange={handleInputChange} />
            </div>
            <div className="mb-4">
                <Selectinput options={generateCompanyTypeOptions()} name="businessType" value={formData.businessType} label="Business type" onChange={handleInputChange} />
            </div>
            <div className="mb-4">
                <TextInput label={"Incorporation Date (YYYY-MM-DD)"} name="incorporationDate" value={formData.incorporationDate} onChange={handleInputChange} />
            </div>
            <div className="mb-4">
                <TextInput label="Website" name="website" value={formData.website} onChange={handleInputChange} />
            </div>
            <div className="mb-4">
                <TextInput label="Phone Number" name="phone" value={formData.phone} onChange={handleInputChange} />
            </div>
            <div className="mb-4">
                <TextInput label="Email Address" name="email" value={formData.email} onChange={handleInputChange} />
            </div>
            <div className="mb-4">
                <Selectinput options={generateMccOptions(mccCodes)} name="mcc" value={formData.mcc} label="MCC" onChange={handleInputChange} />
            </div>
            <div className="mb-4">
                <TextInput label="Business Address Line 1" name="addressLine1" value={formData.addressLine1} onChange={handleInputChange} />
            </div>
            <div className="mb-4">
                <TextInput label="Business Address Line 2" name="addressLine2" value={formData.addressLine2} onChange={handleInputChange} />
            </div>
            <div className="mb-4">
                <TextInput label="City" name="city" value={formData.city} onChange={handleInputChange} />
            </div>
            <StatesSelect handleInputChange={handleInputChange} formData={formData} />
            <div className="mb-4">
                <TextInput label="Zip Code" name="zipcode" value={formData.zipcode} onChange={handleInputChange} />
            </div>
            <div className="mb-4">
            <label className="block text-sm font-medium mb-1">Country</label>
                <p className="bg-slate-200 border w-full text-gray-700 py-2 px-2 
                    leading-tight focus:outline-none">USA</p>
            </div>
            <div className="mb-4">
                <PasswordInput label="EIN" name="ein" value={formData.ein} onChange={handleInputChange} />
            </div>
            <p className="text-sm text-red-500 mb-3">{errmsg}</p>
            <div className="space-x-3">
                <Button disabled={saving} onClick={handleNext}>{saving ? 'Saving...' : 'Continue'}</Button>
            </div>
        </div>
    )
}

